import React, { useState } from "react"
import Circle from "../Circle";
import Description from "../Description";
import Button from "../Button";
import star from "../../images/icon-star.svg"
import thankYou from "../../images/illustration-thank-you.svg"
import "./RatingBox.css"
import { getClasses } from "../../js/classUtils";

function RatingBox({rateScore, title, children}){
    
    const [score, setScore] = useState(undefined);
    const [rated,setRated] = useState(false);
    rateScore = rateScore ? rateScore : 5;

    const scoreButtons = [...Array(rateScore).keys()]
        .map( n => 
            <Circle onClick={() => setScore(n)} active={score === n} key={n}>
                {n + 1}
            </Circle>
    )

    function onSubmit(){
        if (isNaN(score)) return;
        setRated(true);
    }

    let classNames = getClasses({
        ratingBox: true,
        "ratingBox--center": rated
    })

    return (
        <section className={classNames}>
            { !rated ? 
            <React.Fragment>
                <Circle>
                    <img src={star} alt="star-icon" />
                </Circle>
                <Description title={title}>
                    {children}
                </Description>
                <div className="scoreButtons">
                    {scoreButtons}
                </div>
                <Button onClick={onSubmit}>Submit</Button>
            </React.Fragment>
            :
            <React.Fragment>
                <img src={thankYou} alt="thank you" className="ratingBox__img"/>
                <div className="ratingBox__selection">
                    <p className="ratingBox__scoreText">You selected {score + 1} out of {rateScore}</p>
                </div>
                <Description title="Thank you!" centered={true}>
                    We appreciate you taking the time to give a rating.
                    If you ever need more support, don't hesitate to get in touch!
                </Description>
            </React.Fragment>
            }
        </section>
    )
}

export default RatingBox;